export function useToken() {
  const SetToken = (token) =>
  {
    localStorage.setItem('session_token', token);
  };
  const GetToken = () => {
    return localStorage.getItem('session_token')??'NA';
  };

  return { SetToken, GetToken };
}